export default "__VITE_ASSET__lEzvpxaZ__"